// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yKLu","clinicsSelect":"styles_clinicsSelect__O_8S-"};